export enum LifetimePlanIds {
    'GOOSE-VPN-Lifetime-Tier-1-EUR-Yearly' = '1',
    'GOOSE-VPN-Lifetime-Tier-2-EUR-Yearly' = '5',
    'GOOSE-VPN-Lifetime-Tier-3-EUR-Yearly' = '10',
}
